import React from 'react';
import PropTypes from 'prop-types';
import {
  NavItem, NavLink
} from 'reactstrap';
import classnames from 'classnames';

const TabNavItem = ({ activeTab, name, title, toggle }) => (
  <NavItem>
    <NavLink
      className={`cursor-pointer ${classnames({ active: activeTab === name })}`}
      onClick={() => { toggle(name); }}
    >
      <input className="mt-1 mr-1" type="radio" checked={activeTab === name} />
      {title}
    </NavLink>
  </NavItem>
);

TabNavItem.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  activeTab: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired
};

export default TabNavItem;



// WEBPACK FOOTER //
// ./src/components/dashboard/benchmark-tab/TabNavItem.js